import React from "react";
import SimpleBar, { Props } from "simplebar-react";
// SimpleBar lays out its scroll container with this stylesheet; without it nothing scrolls
import "simplebar-react/dist/simplebar.min.css";
import { useSimpleBarRefresher } from "./useSimpleBarRefresher";

type ScrollableProps = React.HTMLAttributes<HTMLElement> &
  Props & {
    /** Height at which the content starts scrolling. */
    maxHeight?: string | number;
    /** Recalculates the scrollbars this many ms after mounting. Default 700. */
    refreshAfterInstall?: number;
  };

/** A SimpleBar scroll container with overlay scrollbars. Prefer `ScrollArea`. */

export const Scrollable: React.FC<ScrollableProps> = ({
  refreshAfterInstall = 700,
  maxHeight,
  ...rest
}) => {
  const { ref } = useSimpleBarRefresher(refreshAfterInstall);
  return <SimpleBar ref={ref} style={{ maxHeight: maxHeight }} {...rest} />;
};
